<template>
  <div>
    <!--筛选栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <DatePicker v-model="filter.startDate" format="yyyy-MM-dd" placeholder="开始日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <DatePicker v-model="filter.endDate" format="yyyy-MM-dd" placeholder="结束日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" @click="onSearch">查询</Button>
      </Cell>
      <Cell>
        <Button @click="onReset">重置</Button>
      </Cell>
      <Cell>
        <Button color="success" @click="openAdd">新增收款单</Button>
      </Cell>
      <Cell>
        <Button @click="doExport">导出</Button>
      </Cell>
    </Row>

    <!--列表-->
    <div class="h-panel-body padding-top">
      <Table :datas="list" :border="true" :loading="loading">
        <TableItem title="单据编号" prop="code" :width="170"></TableItem>
        <TableItem title="日期" prop="billDate" :width="110"></TableItem>
        <TableItem title="收款账户" prop="accountName" :width="140"></TableItem>
        <TableItem title="对方单位" prop="supplierName" :width="160"></TableItem>
        <TableItem title="收款金额" align="right" :width="120">
          <template slot-scope="{data}">{{ money(data.amount) }}</template>
        </TableItem>
        <TableItem title="已关联金额" align="right" :width="120">
          <template slot-scope="{data}">{{ money(data.linkedAmount) }}</template>
        </TableItem>
        <TableItem title="关联源单" prop="orderId" :width="100"></TableItem>
        <TableItem title="摘要" prop="summary"></TableItem>
        <TableItem title="备注" prop="remark" :width="140"></TableItem>
        <TableItem title="凭证状态" :width="110" align="center">
          <template slot-scope="{data}">
            <Tag :color="data.status === 2 ? 'success' : 'warning'">
              {{ data.status === 2 ? '已生成凭证' : '未生成凭证' }}
            </Tag>
          </template>
        </TableItem>
        <TableItem title="操作" :width="70" align="center">
          <span slot-scope="{data}" class="link danger" @click="doDelete(data)">删除</span>
        </TableItem>
      </Table>
      <Pagination :page="filter.page" size="small" :total="total" @change="onPage" class="margin-top text-right"></Pagination>
    </div>

    <!--新增收款单-->
    <Modal v-model="modal" title="新增收款单" width="620">
      <Form label-width="100" :model="form">
        <FormItem label="单据日期">
          <DatePicker v-model="form.billDate" format="yyyy-MM-dd"></DatePicker>
        </FormItem>
        <FormItem label="收款账户">
          <Select v-model="form.accountId" filterable @change="onAccountChange">
            <Option v-for="a in accounts" :value="a.id" :key="a.id">{{ a.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="对方单位">
          <Select v-model="form.supplierId" filterable @change="onSupplierChange">
            <Option v-for="s in suppliers" :value="s.id" :key="s.id">{{ s.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="收款金额">
          <input type="number" v-model.number="form.amount" style="width:100%">
        </FormItem>
        <FormItem label="摘要">
          <input type="text" v-model="form.summary" style="width:100%">
        </FormItem>
        <FormItem label="备注">
          <textarea v-model="form.remark" rows="2" style="width:100%"></textarea>
        </FormItem>
      </Form>
      <div slot="bottom">
        <Button @click="modal = false">取消</Button>
        <Button color="primary" @click="doSave">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'InventoryFundManagement',
  data() {
    return {
      filter: {startDate: '', endDate: '', page: 1},
      list: [],
      total: 0,
      loading: false,
      accounts: [],
      suppliers: [],
      modal: false,
      form: this.blankForm()
    };
  },
  methods: {
    blankForm() {
      return {billDate: new Date(), accountId: null, accountName: '', supplierId: null, supplierName: '', amount: 0, summary: '', remark: ''};
    },
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    fmt(d) {
      let dt = d instanceof Date ? d : new Date(d);
      return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
    },
    loadOptions() {
      this.$api.funds.account.list().then(({data}) => {
        this.accounts = data.records || data.results || data || [];
      }).catch(() => {});
      this.$api.setting.inventorySupplier.list({page: 1, size: 500}).then(({data}) => {
        this.suppliers = data.records || data.results || data || [];
      }).catch(() => {});
    },
    loadList() {
      this.loading = true;
      let p = {
        page: this.filter.page,
        pageSize: 20,
        startDate: this.filter.startDate ? this.fmt(this.filter.startDate) : '',
        endDate: this.filter.endDate ? this.fmt(this.filter.endDate) : ''
      };
      this.$api.pro.inventory.receiptList(p).then(({data}) => {
        this.list = data.results || [];
        this.total = data.total || 0;
      }).finally(() => this.loading = false);
    },
    onSearch() {
      this.filter.page = 1;
      this.loadList();
    },
    onReset() {
      this.filter = {startDate: '', endDate: '', page: 1};
      this.loadList();
    },
    onPage(page) {
      this.filter.page = page;
      this.loadList();
    },
    openAdd() {
      this.form = this.blankForm();
      this.modal = true;
    },
    onAccountChange(id) {
      let a = this.accounts.find(x => x.id === id);
      this.form.accountName = a ? a.name : '';
    },
    onSupplierChange(id) {
      let s = this.suppliers.find(x => x.id === id);
      this.form.supplierName = s ? s.name : '';
    },
    doSave() {
      if (!this.form.accountId || !(Number(this.form.amount) > 0)) {
        this.$Message.warning('请选择收款账户并填写金额');
        return;
      }
      this.$api.pro.inventory.receiptSave(this.form).then(() => {
        this.$Message.success('收款单保存成功');
        this.modal = false;
        this.loadList();
      });
    },
    doDelete(row) {
      this.$Confirm(`确认删除收款单 ${row.code}？`).then(() => {
        this.$api.pro.inventoryFund.del(row.id).then(() => {
          this.$Message.success('删除成功');
          this.loadList();
        });
      });
    },
    doExport() {
      if (!this.list.length) {
        this.$Message.warning('没有可导出的数据');
        return;
      }
      let header = ['单据编号', '日期', '收款账户', '对方单位', '收款金额', '已关联金额', '摘要', '备注'];
      let lines = this.list.map(r => [r.code, r.billDate, r.accountName, r.supplierName, r.amount, r.linkedAmount, r.summary, r.remark]);
      let csv = [header].concat(lines).map(a => a.map(v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`).join(',')).join('\n');
      let blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8'});
      let url = URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      a.download = '资金收款单.csv';
      a.click();
      URL.revokeObjectURL(url);
    }
  },
  mounted() {
    this.loadOptions();
    this.loadList();
  }
};
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 10px;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
  &.danger {
    color: #ed4014;
  }
}
</style>
